module.exports = __webpack_public_path__ + "img/pen-blue.b064529c.svg";